import CallDetails from './CallDetails'

export default CallDetails